import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import * as Papa from 'papaparse';
import { SettingService } from '../services/settingService/setting.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { CCCName } from '../services/settingService/setting.enum';
import { Router } from '@angular/router';
import { MatRadioChange } from '@angular/material/radio';
const FileSaver = require('file-saver');

@Component({
  selector: 'app-import',
  templateUrl: './import.component.html',
  styleUrls: ['./import.component.scss']
})
export class ImportComponent implements OnInit {

  step:number = 1;
  OfficeIDList: any=[];
  myOfficeID: any;
  databaseId: string;
  organizationId: string;
  currentUser: any;
  userId:string="";
  menuModulesList:any=[]=[];
  spinner:boolean=false;
  StepNextButton:boolean=false;
  FolderId:number=0;
  FolderName:string="";
  records: any=[] = [];
  columnsHeader:any=[] = [];
  columnsNewHeader:any=[] = [];
  columnsdata:any=[] = [];
  @ViewChild('Input') InputFile: ElementRef;
  UploadedFiles:any= []=[];  
  responseHolder: any;
  ErrorMessage:boolean=false;
  Feildproperty:any=[] = []; 
  checkedAll:boolean=false;
  StepNextButtonStep3:boolean=false;
  Type:number=0;
  formData: FormData = new FormData();
  ResponseHolderDetails: any;
  IsValid:boolean=false;
  ImportButton:boolean=false;
  MainModuleName:string="";
  disabledGrid:boolean=false;
  InValidRowNumbers:any=[]=[];

  constructor(private reusableClass:ReusableClasses,private encryptionAlgo: EncryptionService,
     private statusConstant: StatusConstant, private toastr: ToastrService,
     private settingsService: SettingService,private loaderService: LoaderService,private router: Router) { 
      const encryptedtoken = sessionStorage.getItem('userToken');
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.databaseId = sessionStorage.getItem('databaseId');
      this.organizationId = sessionStorage.getItem('organizationID');
      this.currentUser = jwt_decode(token);
      var offices=[];
      offices=JSON.parse(sessionStorage.getItem('officeList'));
      if(offices.length>0){
        offices.forEach(oe => {
          this.OfficeIDList.push(oe.officeID)	
          if(oe.isMyoffice==true)
            this.myOfficeID=oe.officeID;
          });
       }
    }
    
  ngOnInit(): void {
     //var base64URL= 'Um93Tm8sRXJyb3INCg==';
     // const data = 'data:text/csv;base64,' + base64URL;
     // FileSaver.saveAs(data, 'CSVErrors');    
     this.Feildproperty=[];
     this.columnsNewHeader=[];
     this.InValidRowNumbers=[];
     this.disabledGrid=false;
     this.ImportButton=false;
     this.IsValid=false;
     this.step=1;
     var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
     this.menuModulesList=  menuModulesList.filter(x => x.mainModuleName == CCCName.Core || x.mainModuleName == CCCName.Contact ||x.mainModuleName == CCCName.Company);
     this.menuModulesList = this.menuModulesList.filter(x => x.isAssign == true);
  }

  // Choose Core/Contact/Company From Radio Button
  CCCSelect(event,record) {
    this.FolderId=record.folderID;
    this.FolderName=record.orgModuleName;
    this.MainModuleName= record.mainModuleName;
    this.StepNextButton=true;
    if(record.mainModuleName==CCCName.Core){
      this.Type=1;
    }
    if(record.mainModuleName==CCCName.Contact){
      this.Type=2;
    }
    if(record.mainModuleName==CCCName.Company){
      this.Type=3;
    }
    this.menuModulesList.forEach(e => {
      e.isChecked = false
    });
    this.menuModulesList.forEach(e => {
      if (e.folderID == record.folderID) {
        e.isChecked = true
      }
    });
  }

  // CSV File Upload // 
  uploadCSVFile(files: File[]){
    if(this.UploadedFiles.length>0){
       this.InputFile.nativeElement.value = '';
       this.toastr.warning('Allowed only 1 csv file for import.', '', {
          timeOut: 3000,
        });
       return;
     }
    if (this.isValidCSVFile(files[0])){
      Papa.parse(files[0], {
        header: true,
        skipEmptyLines: true,
        complete: (result,file) => {  
          var FullPath = file.name;
          var documentNameSplit = FullPath.split('.');
          var documentName = documentNameSplit[0];
          var documenttype = file.name.split('.').pop();
          var size= this.getReadableFileSizeString(file.size);
          var ReqModel = {
            id: 1,
            fileName: documentName,
            documentType: documenttype,
            file: file,
            Totalsize:size,
          };
          this.columnsdata = result.data; // For Getting Data
          this.columnsHeader = result.meta.fields; // For Getting Header
          if(this.columnsHeader.length > 0 && this.columnsdata.length > 0){
            if(this.columnsdata.length > 1000){
              this.toastr.warning('Only one thousand rows in csv are allowed.', '', {
                timeOut: 3000,
              });
            }else{
              this.UploadedFiles.push(ReqModel);
              this.StepNextButton=true;
            }
          }else{
            this.toastr.warning('Please import valid .csv file.', '', {
              timeOut: 3000,
            });
          }
          this.InputFile.nativeElement.value = '';
        }
      });
    } else {
      this.InputFile.nativeElement.value = '';
      this.toastr.warning('Please import valid .csv file.', '', {
        timeOut: 3000,
      });
    }
  }
 

  getReadableFileSizeString(fileSizeInBytes) {
    var i = -1;
    var byteUnits = [' KB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    do {
        fileSizeInBytes = fileSizeInBytes / 1024;
        i++;
    } while (fileSizeInBytes > 1024);

    return Math.max(fileSizeInBytes).toFixed(3) + byteUnits[i];
  };

  //check extension
  isValidCSVFile(file: any) {
    return file.name.endsWith(".csv");
  }

  // For Click on Validate CSV //
  ValidateCSV() {   
    this.StepNextButtonStep3=false;
    if(this.columnsNewHeader.length>0){
      var CheckIsImport=[];
      var CheckDuplicateProperty=[];
      CheckDuplicateProperty=this.columnsNewHeader.filter(x=> x.IsImport == true);  
      CheckIsImport = this.columnsNewHeader.filter(x=> x.IsImport == true);  
      CheckIsImport =  CheckIsImport.map(({ id,Feildproperty, ...item }) => item);
      //CheckIsImport.forEach(function(x){ delete x.id });

      const lookup = CheckIsImport.reduce((a, e) => {
        a[e.FieldID] = ++a[e.FieldID] || 0;
        return a;
        },{});

      CheckDuplicateProperty= CheckDuplicateProperty.filter(e => lookup[e.FieldID]);
      CheckDuplicateProperty =CheckDuplicateProperty.filter(e => e.FieldName!="Email" && e.FieldName!="Phone" && e.FieldName!="Address");
      if(CheckDuplicateProperty.length>0){
        this.toastr.warning('Email,Phone and Address can be map multiple time,rest not.', '', {
          timeOut: 3000,
        });
        this.StepNextButtonStep3=false;
        return;
      }      
    }       
    this.loaderService.show();
    this.formData = new FormData();
    this.formData.append('Type', (this.Type).toString());
    this.formData.append('FolderID', (this.FolderId).toString());
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('OfficeID', this.myOfficeID);
    this.formData.append('OrganizationID', this.organizationId);
    this.formData.append('MappedFields', JSON.stringify(CheckIsImport));  
    this.formData.append('Files', this.UploadedFiles[0].file);
    this.settingsService.ValidateCSV(this.formData).subscribe((response) => {
    if (response != undefined) {
       this.ResponseHolderDetails = response;
       this.IsValid=true;
       this.disabledGrid=true;
       this.InValidRowNumbers=this.ResponseHolderDetails.inValidRowNumbers;
       if(this.InValidRowNumbers.length==0){
        this.InValidRowNumbers=[-1];
       }
       if(this.ResponseHolderDetails.isvalid==true && this.ResponseHolderDetails.inValidRows==0){
         this.toastr.success('Uploaded CSV file have valid data rows. Click on "Import" button for import data.', '', {
            timeOut: 3000,
         });
       }
       if(this.ResponseHolderDetails.isvalid==false && this.ResponseHolderDetails.inValidRows>0){
           var base64URL=this.ResponseHolderDetails.errorFile;
           const data = 'data:text/csv;base64,' + base64URL;
           FileSaver.saveAs(data, 'CSVErrors');
           this.toastr.warning('Uploaded CSV file have '+this.ResponseHolderDetails.inValidRows+'/'+this.ResponseHolderDetails.total+' invalid data row(s). you can still import '+this.ResponseHolderDetails.validRows+'/'+this.ResponseHolderDetails.total+' valid data row(s). Invalid data row(s) you can fix and import those later. Click on "Import" button for import data.', '', {
            timeOut: 7000,
          });
        }      
         this.loaderService.hide();
        }else{
          this.loaderService.hide();
        }
      }); 
  }

   // For Click on Import  //
   ImportClick(){
    this.StepNextButtonStep3=false;
    if(this.columnsNewHeader.length>0){
      var CheckIsImport=[];     
      CheckIsImport = this.columnsNewHeader.filter(x=> x.IsImport == true);  
      CheckIsImport =  CheckIsImport.map(({ id,Feildproperty, ...item }) => item);      
    } 
    var ImportType;     
    if(this.importType==1){
      ImportType=0;
    }
    if(this.importType==2){
      ImportType=1;
    }
    if(this.importType==3){
      ImportType=2;
    }
    if(this.importType==4){
      ImportType=3;
    }
    this.loaderService.show();
    this.formData = new FormData();
    this.formData.append('Type', (this.Type).toString());
    this.formData.append('FolderID', (this.FolderId).toString());
    this.formData.append('UserID', this.currentUser.UID);
    this.formData.append('OfficeID', this.myOfficeID);
    this.formData.append('OrganizationID', this.organizationId);
    this.formData.append('MappedFields', JSON.stringify(CheckIsImport));
    this.InValidRowNumbers.forEach(e => {
      this.formData.append('InValidRowNumbers',e);
    });  
    this.formData.append('Files', this.UploadedFiles[0].file);
    this.formData.append('ImportType', ImportType);  
    this.settingsService.ImportTripleCCSV(this.formData).subscribe((response) => {
    if (response != undefined) {
       this.ResponseHolderDetails = response;
        if(this.ResponseHolderDetails == true) {
           this.loaderService.hide();
           this.toastr.success('Record imported successfully', '', {
            timeOut: 3000,
           });
           if(this.MainModuleName==CCCName.Core){
            this.router.navigate(['/core/listing']);
           }
           if(this.MainModuleName==CCCName.Contact){
            this.router.navigate(['/contact/listing']);
           }
           if(this.MainModuleName==CCCName.Company){
            this.router.navigate(['/company/listing']);
           }
          } else {
            this.loaderService.hide();
          }
        }else{
          this.loaderService.hide();
        }
      }); 
   }
   
   // For Next // 
   proceed(){
     if(this.step==2){
      if(this.importType==0){
        this.toastr.warning('Please select import type.', '', {
          timeOut: 3000,
         });
         return;
      }
     }
    if(this.UploadedFiles.length>0){
       this.StepNextButton=true;
       this.StepNextButtonStep3=false;
       this.checkedAll=true;
       this.columnsNewHeader=[];
       this.InValidRowNumbers=[];
       this.getFieldForImportExport();     
    }
    else{
      this.StepNextButton=false;
    }
    this.step++;
    if(this.step>=3){
      this.step=3;
    }

    if(this.importType==1){
      this.showContent="Import All if you want to Import all csv.";    
     }
     if(this.importType==2){
       this.showContent="De-Duplicate Content";      
     }
     if(this.importType==3){
       this.showContent="Archive Only if you want to Archive all matching records from csv.";      
     }
     if(this.importType==4){
       this.showContent="Archive & Import Content";      
     }
   }

   // For Back // 
   back(){
    this.disabledGrid=false;
    this.ImportButton=false;
    this.IsValid=false;
    this.StepNextButton=true;    
    this.step--;  
    // if(this.step==1){
    //   this.showContent="";
    //   this.importType=0;
    // } 
   }
  
   
  // GetFieldForImportExport for Dropdown // 
  getFieldForImportExport() {
    this.loaderService.show();
    var ReqModel = {
      folderID: this.FolderId,
      UserId: this.currentUser.UID,
      OrganizationID:  Number(this.organizationId),      
      officeID: this.myOfficeID,
     }
     this.settingsService.GetFieldForImportExport(ReqModel).subscribe(response => {
     if(response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConstant.statusSuccess) {
          this.Feildproperty = this.responseHolder.data;         
          this.Feildproperty= this.Feildproperty.sort((a,b) => a.fieldName.toLowerCase() > b.fieldName.toLowerCase() ? 1 : -1)
          if(this.columnsHeader.length>0){
            this.checkedAll=true;
            for (let i = 0; i < this.columnsHeader.length; i++){
              var obj={
                id:i+1,
                FieldID:0,
                CsvFieldName:this.columnsHeader[i],
                IsImport:true,
               // Feildproperty:this.Feildproperty,               
                FieldName:""
              }
              this.columnsNewHeader.push(obj);
            }            
          }
          this.loaderService.hide();
        }else{
          this.Feildproperty =[];
          this.loaderService.hide();
        }
      }else{
        this.Feildproperty =[];
        this.loaderService.hide();
      }
    });
  }  

  //Checkbox for Particular 
  getCheckboxParticular(event, file) {
    if(this.columnsNewHeader.length>0){
      if(event.checked==true){
        this.columnsNewHeader.forEach(e => {
          if (e.id == file.id) {
            e.IsImport = true
          }
        });      
      }else{
        this.columnsNewHeader.forEach(e => {
          if (e.id == file.id) {
            e.IsImport = false
          }
        });      
      }
      var CheckIsImport=[];
      CheckIsImport=this.columnsNewHeader.filter(x=> x.IsImport == false);
      if(CheckIsImport.length>0){
        this.checkedAll=false;
      }else{
        this.checkedAll=true;
      }
      var CheckRecord=[];
      CheckRecord = this.columnsNewHeader.filter(x=> x.IsImport == true);
      if(CheckRecord.length>0){
        for (var i = 0, len = CheckRecord.length; i < len; ++i) {       
          if (CheckRecord[i].FieldID >0) {
            this.StepNextButtonStep3=true;          
          }else{
            this.StepNextButtonStep3=false;
            return;
          }
        }
      }else{
        this.StepNextButtonStep3=false;
      }
    }   
  }

   //Checkbox for All 
   getCheckboxAll(event) {
     if(event.checked==true){
      this.checkedAll=true;      
      this.columnsNewHeader.forEach(e => {
       e.IsImport = true;
     });  
     var CheckRecords=[];
     CheckRecords = this.columnsNewHeader.filter(x=> x.IsImport == true);
     if(CheckRecords.length>0){
        for (var i = 0, len = CheckRecords.length; i < len; ++i) {          
            if (CheckRecords[i].FieldID >0) {
            this.StepNextButtonStep3=true;
          }else{
            this.StepNextButtonStep3=false;
            return;
          }
        }
      }else{
        this.StepNextButtonStep3=false;
      }
     }else{
       this.checkedAll=false;
       this.StepNextButtonStep3=false;
       this.columnsNewHeader.forEach(e => {
        e.IsImport = false;      
      });  
    }
   }   

   //Select Feild Property from Dropdown list
   selectFeildProperty(event:any,file:any){
    var CheckAlreadySelect=[];
    CheckAlreadySelect = this.columnsNewHeader.filter(x=> x.id == file.id);
    if(CheckAlreadySelect.length>0){ // Chceck For Replace Selected Property
      var CheckData=[];
      CheckData = this.Feildproperty.filter(x=> x.fieldID == event.value);
      if(CheckData.length>0){
        this.columnsNewHeader.find((item) => item.id == file.id).FieldID = event.value;
        this.columnsNewHeader.find((item) => item.id == file.id).FieldName = CheckData[0].fieldName;       
      }
      var CheckRecord=[];
      CheckRecord = this.columnsNewHeader.filter(x=> x.IsImport == true);
      if(CheckRecord.length>0){
        for (var i = 0, len = CheckRecord.length; i < len; ++i) {
            if (CheckRecord[i].FieldID >0){
            this.StepNextButtonStep3=true;            
          }else{
            this.StepNextButtonStep3=false;
            return;
          }
        }
      }else{
        this.StepNextButtonStep3=false;
      }
    }else{
    }
   }
  
   //Delete CSV file from step 2 
   deleteFileFromUploaded(){
    this.InputFile.nativeElement.value = '';
    this.UploadedFiles=[];
    this.columnsHeader=[];
    this.columnsNewHeader=[];
    this.InValidRowNumbers=[];
    this.Feildproperty=[];
    this.StepNextButton=false;
   }

   OpenStep(step){
    this.step=step;
   }

   showContent:string="";
   importType:number=0;   
   ImportAll:boolean=false;
   DeDuplicate:boolean=false;
   ArchiveOnly:boolean=false;
   ArchiveImport:boolean=false;

   ChangeGroupType(event: MatRadioChange,Type){
    if(Type==1){
     this.showContent="Import All Content";
     this.importType=1;

     this.ImportAll=true;
     this.DeDuplicate=false;
     this.ArchiveOnly=false;
     this.ArchiveImport=false;
    }
    if(Type==2){
      this.showContent="De-Duplicate Content";
      this.importType=2;

      this.ImportAll=false;
      this.DeDuplicate=true;
      this.ArchiveOnly=false;
      this.ArchiveImport=false;
    }
    if(Type==3){
      this.showContent="Archive Only Content";
      this.importType=3;

      this.ImportAll=false;
      this.DeDuplicate=false;
      this.ArchiveOnly=true;
      this.ArchiveImport=false;
    }
    if(Type==4){
      this.showContent="Archive & Import Content";
      this.importType=4;

      this.ImportAll=false;
      this.DeDuplicate=false;
      this.ArchiveOnly=false;
      this.ArchiveImport=true;
    }
   }
 
}
